import TotalTimeLog from "../TabsCard/TotalTimeLog";
import TasksOverview from "../TabsCard/TasksOverview";
import PhysicalSignOffSheet from "../TabsCard/PhysicalSignOffSheet";
import EngineerSignature from "../TabsCard/EngineerSignature";
import ClientSignature from "../TabsCard/ClientSignature";
import BaseCard from "../../../components/ui/BaseCard";
import { useFormik } from "formik";
import * as yup from "yup";
import { useEffect } from "react";
import useAuth from "../../../hooks/useAuth";

const validationSchema = yup.object({
  companyName: yup
    .string("Enter Institution Name")
    .required("Company Name is required"),
  designation: yup
    .string("Enter designation")
    .required("Designation is required"),
  country: yup.string().required("Country is required"),
  city: yup.string().required("city is required"),
  startDate: yup.string().required("start date is required"),
  endDate: yup.string().required("end date is required"),
});

const SignOffTab = ({ workOrderDetail, setSignOffSheetData, mode }) => {
  const { auth } = useAuth();

  const formik = useFormik({
    initialValues: {
      workOrderId: workOrderDetail?.id,
      clientName: workOrderDetail?.signOffSheet?.clientName,
      clientDesignation: workOrderDetail?.signOffSheet?.clientDesignation,
      clientComment: workOrderDetail?.signOffSheet?.clientComment || "",
      clientSignatureFile: workOrderDetail?.signOffSheet?.clientSignature,
      physicalSheetFile: workOrderDetail?.signOffSheet?.physicalSheet,
      clientId: workOrderDetail?.createdBy?.id,
      engineerComment: workOrderDetail?.signOffSheet?.engineerComment || "",
      engineerSignatureFile: workOrderDetail?.signOffSheet?.engineerSignature,
      engineerId: auth?.user?.id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => { },
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
  });
  useEffect(() => {
    if (formik.values && mode === "WRITE") {
      setSignOffSheetData(formik.values); // Update data only when values change
    }
  }, [formik.values, setSignOffSheetData]);

  return (
    <div className="grid grid-cols-2 gap-2">
      <BaseCard
        className="col-span-2 pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-3"
        elevation={1}
      >
        <div className="border-bottom mb-4 flex items-center pb-1">
          <h6 className={"!text-primary"}>Job Assignment Signoff</h6>
        </div>
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-10 w-full">
          <TotalTimeLog
            totalHours={workOrderDetail?.totalHours}
            timeLogs={workOrderDetail?.timeLogs}
            timeZone={workOrderDetail?.timeZone}
            engineerName={`${workOrderDetail?.engineer?.firstName} ${workOrderDetail?.engineer?.lastName}`}
          />

          <TasksOverview tasks={workOrderDetail?.formattedTasks} mode={mode} />
        </div>
      </BaseCard>
      <BaseCard
        className="col-span-2 pt-4 pb-6 px-1 rounded-lg !mb-3"
        elevation={1}
      >
        <div className="col-span-2 ">
          <EngineerSignature formik={formik} mode={mode} engineer={workOrderDetail?.engineer} />
        </div>
        <div className="mr-16 ml-16 border-b-2 !border-[#0F40AE] mb-3 mt-3 pb-1"></div>
        <div className="col-span-2">

          <ClientSignature formik={formik} mode={mode} />
        </div>
      </BaseCard>
      <div
        className="col-span-2 pt-4 pb-6 px-1 rounded-lg !mb-3"
        elevation={1}
      >
        <PhysicalSignOffSheet formik={formik} mode={mode} workOrderId={workOrderDetail?.id} workOrderRefId={workOrderDetail?.referenceId} />
      </div>
    </div>
  );
};

export default SignOffTab;
